import React, { createContext, useContext, useEffect, useState } from "react";
import { API } from "@/lib/api";

const CurrencyContext = createContext(null);

// Geo-locked (Part B): the server decides the currency from IP/header/cookie.
// The client cannot freely toggle; it can only request a verified switch to INR.
export function CurrencyProvider({ children }) {
  const [currency, setCurrencyState] = useState("usd");
  const [ready, setReady] = useState(false);
  const [country, setCountry] = useState("");

  const refresh = () =>
    fetch(`${API}/geo`, { credentials: "include" })
      .then((r) => r.json())
      .then((d) => { setCurrencyState(d.currency || "usd"); setCountry(d.country || ""); setReady(true); })
      .catch(() => { setCurrencyState("usd"); setReady(true); });

  useEffect(() => { refresh(); }, []);

  const switchToInr = async () => {
    const r = await fetch(`${API}/geo/switch-inr`, { method: "POST", credentials: "include" });
    if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.detail || "Could not switch"); }
    setCurrencyState("inr");
    return true;
  };
  const switchToUsd = async () => {
    await fetch(`${API}/geo/switch-usd`, { method: "POST", credentials: "include" });
    setCurrencyState("usd");
  };

  return (
    <CurrencyContext.Provider value={{ currency, country, ready, switchToInr, switchToUsd, refresh }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);

export function money(currency, amount) {
  const n = Number(amount || 0);
  if (currency === "inr") return "₹" + n.toLocaleString("en-IN");
  return "$" + n.toLocaleString("en-US", { minimumFractionDigits: n % 1 ? 2 : 0 });
}

// legacy signature kept for any callers passing both prices
export function fmt(currency, inr, usd) {
  return money(currency, currency === "inr" ? inr : usd);
}
